import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { start } from './process.js';

var _excluded = ["implementation"];
function startStandalone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var implementation = options.implementation,
    rest = _objectWithoutProperties(options, _excluded);
  start(implementation, Object.keys(rest).length > 0 ? rest : undefined);
}
if (typeof window !== 'undefined') {
  window.locizeStartStandalone = startStandalone;
}

export { startStandalone };
